export const saveToClipboard = (content: string, addAlert: any, msg?: string) =>
  navigator.clipboard
    .writeText(content)
    .then(addAlert({ type: "success", title: msg || "Link copied to clipboard" }));
